import { addons } from "@storybook/manager-api";
import theme from "./theme";
import { toSentenceCase } from "../core/js/utilities/to-sentence-case.js";

addons.setConfig({
    theme,
    sidebar: {
        renderLabel: ({ name }) => toSentenceCase(name),
    },
});
